module.exports = __webpack_public_path__ + "img/logo.5d8b2d98.svg";